<div class="flex flex-row align-items-center content-center mb-10 gap-10">
  <img src="{{pollStatusIcon}}">
  <div>
    <p class="no-margin dark-gray">scrutin</p>
    <h3 class="cell-header no-margin dark-blue">{{pollTitle}}
      <span *ngIf="category == 0" class="orange">({{polls.length}})</span>
      <span *ngIf="category == 1" class="light-blue">({{polls.length}})</span>
      <span *ngIf="category == 2" class="green">({{polls.length}})</span>
      <span *ngIf="category == 3" class="dark-red">({{polls.length}})</span>
    </h3>
  </div>
</div>
<div *ngIf="isExpanded == false" class="holder-column">
  <div class="inner-holder-column">
    <div class="inner-column">
      <img src="{{arrowIcon}}" alt="arrow" width="24" height="24" class="arrow-icon">
      <div *ngIf="polls.length == 0" class="no-polls">
        <h3 class="dark-blue bold text-md">{{'POLL-DASHBOARD.NONE' | translate}}</h3>
      </div>
      <div class="has-polls" *ngFor="let poll of polls | slice:0:5; let i = index">
        <vc-poll-dashboard-item *ngIf="category == 0" [pollData]="poll" [column]=0 (openPollEvent)="editPoll(poll.id)"
          (deletePollEvent)="refreshPolls()" (editPollEvent)="editPoll(poll.id)"
          (clonePollEvent)="clonePoll(poll.id, false)">
        </vc-poll-dashboard-item>
        <vc-poll-dashboard-item *ngIf="category == 1" [pollData]="poll" [column]=1
          (openPollEvent)="navigateToPlannedPoll(poll.id)" (deletePollEvent)="refreshPolls()"
          (editPollEvent)="editPoll(poll.id)" (clonePollEvent)="clonePoll(poll.id, true)" [super]="super">
        </vc-poll-dashboard-item>
        <vc-poll-dashboard-item *ngIf="category == 2" [pollData]="poll" [column]=2
          (openPollEvent)="navigateToOngoingPoll(poll.id)" (clonePollEvent)="clonePoll(poll.id, true)" [super]="super">
        </vc-poll-dashboard-item>
        <vc-poll-dashboard-item *ngIf="category == 3" [pollData]="poll" [column]=3
          (openPollEvent)=navigateToClosedPoll(poll.id) (deletePollEvent)="refreshPolls()"
          (clonePollEvent)="clonePoll(poll.id, true)">
        </vc-poll-dashboard-item>
      </div>
    </div>

    <div *ngIf="polls.length > 5">
      <h5 class="see-more" id="expand-{{category}}" (click)=seeMore(true)>{{'POLL-DASHBOARD.SEE-ALL' | translate}}
        ({{polls.length - 5}})</h5>
    </div>
  </div>

</div>

<div *ngIf="isExpanded == true" class="holder-column-expanded">

  <div class="inner-holder-column">
    <img src="{{arrowIcon}}" alt="arrow" width="24" height="24" class="arrow-icon">

    <div class="has-polls" *ngFor="let poll of polls; let i = index">
      <vc-poll-dashboard-item *ngIf="category == 0" [pollData]="poll" [column]=0 (openPollEvent)="editPoll(poll.id)"
        (deletePollEvent)="refreshPolls()" (editPollEvent)="editPoll(poll.id)"
        (clonePollEvent)="clonePoll(poll.id, false)">
      </vc-poll-dashboard-item>
      <vc-poll-dashboard-item *ngIf="category == 1" [pollData]="poll" [column]=1
        (openPollEvent)="navigateToPlannedPoll(poll.id)" [super]="super" (deletePollEvent)="refreshPolls()"
        (editPollEvent)="editPoll(poll.id)" (clonePollEvent)="clonePoll(poll.id, true)">
      </vc-poll-dashboard-item>
      <vc-poll-dashboard-item *ngIf="category == 2" [pollData]="poll" [column]=2
        (openPollEvent)=navigateToOngoingPoll(poll.id) (deletePollEvent)="refreshPolls()"
        (editPollEvent)="editPoll(poll.id)" (clonePollEvent)="clonePoll(poll.id, true)" [super]="super">
      </vc-poll-dashboard-item>
      <vc-poll-dashboard-item *ngIf="category == 3" [pollData]="poll" [column]=3
        (openPollEvent)=navigateToClosedPoll(poll.id) (deletePollEvent)="refreshPolls()"
        (clonePollEvent)="clonePoll(poll.id, true)">
      </vc-poll-dashboard-item>
    </div>
    <div *ngIf="polls.length > 5">
      <h5 class="see-more" (click)=seeMore(false)>{{'POLL-DASHBOARD.SEE-LESS' | translate}}</h5>
    </div>
  </div>
</div>